/**
 * @Author: Fannie
 * @Date:   2018-04-25T08:55:02+08:00
 * @Last modified by:

 * @Last modified time: 2018-04-25T08:55:02+08:00
 */

import _util from '../../utils/';

const employeeHome = {
    fetchEmployeeTips (params, resolve, reject) {
        _util.request({
            url: '/api/EmpPointFrontPage/FrontPageTips',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchEmployeeImportantTips (params, resolve, reject) {
        _util.request({
            url: '/api/EmpPointFrontPage/ImportantTips',
            params: params,
            success: resolve,
            error: reject
        })
    },
    closeEmployeeImportantTips (params, resolve, reject) {
        _util.request({
            url: '/api/EmpPointFrontPage/CloseImportantTips',
            params: params,
            success: resolve,
            error: reject,
            method: 'PUT',
        })
    },
    
}


export default employeeHome;


// WEBPACK FOOTER //
// ./src/services/Employee/employee-home-service.js